// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1rQAS","col":"CardReaderDesc_col__3QCFG","label":"CardReaderDesc_label__3cMWS"};